module.exports = __webpack_public_path__ + "img/world.5c714f47.jpg";